import { Root as o } from "@radix-ui/react-dialog";
import { Root as A } from "@radix-ui/react-dialog";
import { DialogContentActions as t } from "./actions/actions.js";
import { DialogContentBody as i } from "./body/body.js";
import { DialogContentActionsClose as a } from "./close/close.js";
import { DialogContent as e } from "./content/content.js";
import { DialogContentHeader as n } from "./header/header.js";
import { DialogTrigger as s } from "./trigger/trigger.js";
const p = Object.assign(o, {
  Trigger: s,
  Content: Object.assign(e, {
    Header: n,
    Body: i,
    Actions: Object.assign(t, {
      Close: a
    })
  })
});
export {
  p as Dialog,
  e as DialogContent,
  t as DialogContentActions,
  a as DialogContentActionsClose,
  i as DialogContentBody,
  n as DialogContentHeader,
  A as DialogRoot,
  s as DialogTrigger
};
